export default __webpack_public_path__ + "static/media/convert-reward-to-ecredit-step4.32d240a9.png";